import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import BannerBase from '../../components/BannerBase';
import CardInfo from '../../components/CardInfo/CardInfo';
import WrapperCard from '../../components/WrapperCard';
import RecommendationsCard from '../../components/RecommendationsCard';
import TitleTabs from '../../components/TitleTabs';
// import SeasonalSwiper                 from '../../components/SeasonalSwiper';
import OnlineClub from '../../components/OnlineClub';
import { useLoading } from '../../utils/useLoading';
import { ProductRecommendations } from '../../store/actions/ProductRecommendations';
import { productRandomListSelector } from '../../store/selectors/ProductRecommendations';
import {
  HeroBanner,
  HeroBannerGroup,
  HeroBannerSlider
} from '../../store/actions/HeroBanner';
import { ProductBest } from '../../store/actions/ProductBest';
import { productBestListSelector } from '../../store/selectors/ProductBest';
import {
  heroBannerGroupListSelector,
  heroBannerListSelector,
  heroBannerSliderListSelector
} from '../../store/selectors/HeroBanner';
import { citySelector } from '../../store/selectors/City';
import style from './Home.module.scss';

function Home() {
  const { setLoading } = useLoading();
  const dispatch = useDispatch();
  const [ init, setInit ] = useState(false);
  const productList = useSelector(productRandomListSelector);
  const group_slider = useSelector(heroBannerGroupListSelector);
  const banner = useSelector(heroBannerListSelector);
  const slider = useSelector(heroBannerSliderListSelector);
  const { city } = useSelector(citySelector);
  const list = useSelector(productBestListSelector);

  const product = useCallback(async () => {
    await dispatch(ProductRecommendations(city?.id));
  }, [ city ]);

  const bestSellers = useCallback(async () => {
    await dispatch(ProductBest(city?.id));
  }, [ city ]);

  const heroBanner = useCallback(async () => {
    await dispatch(HeroBanner('banner'));
  }, []);

  const groupBanner = useCallback(async () => {
    await dispatch(HeroBannerGroup('slider'));
  }, []);

  const sliderBanner = useCallback(async () => {
    await dispatch(HeroBannerSlider('group_banner'));
  }, []);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const fetchData = async () => {
      setLoading(true);
      window.scrollTo(0, 0);

      if (!productList.length > 0) await product();

      if (!list.length > 0) await bestSellers();

      if (!group_slider.length > 0) await groupBanner();
      if (!banner.length > 0) await heroBanner();
      if (!slider.length > 0) await sliderBanner();

      if (!init) setInit(true);

      setLoading(false);
    };

    fetchData();

    return () => {
      setLoading(true);
      setInit(false);
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      window.scrollTo(0, 0);

      await product();

      await bestSellers();

      setLoading(false);
    };

    if (init) fetchData();
  }, [ city?.id ]);

  return (
      <section className={style.home}>
          <Helmet>
              <title>Аптека Farmacia | Головна </title>
          </Helmet>
          <BannerBase />
          <CardInfo />
          {productList?.length > 0 && (
          <WrapperCard
              data={productList || []}
              option={{
            nav : true
          }}
        >
              <RecommendationsCard />
          </WrapperCard>
      )}

          {list.length > 0 && (
          <WrapperCard
              data={list || []}
              link={'blog'}
              option={{
            nav : true
          }}
        >
              <TitleTabs />
          </WrapperCard>
      )}

          {/* <SeasonalSwiper /> */}
          <OnlineClub />
      </section>
  );
}

export default React.memo(Home);
